export const ModuleConst = {
  Dashboard: 1,
  ManageBookings: 4,
  ManageEmployees: 2,
  ManageSubAdmin: 6,
  Catalogues: 13,
  RevenueManagement: 7,
  Analytics: 8,
  ManageSettings: 14
};
